export default __webpack_public_path__ + "assets/images/0a0de706ab638e4fa676a19fea953133.png";